var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _g2, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifecycleBoard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 134,
    viewBox: "0 0 314 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_679_28302)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.2856,
    y: 5,
    width: 290.514,
    height: 113.371,
    rx: 7.08571,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35.1143,
    y: 40.4286,
    width: 82.3714,
    height: 67.3143,
    rx: 5.31429,
    fill: "#ECECEC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 123.686,
    y: 40.4286,
    width: 81.4857,
    height: 67.3143,
    rx: 5.31429,
    fill: "#ECECEC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 211.372,
    y: 40.4286,
    width: 82.3714,
    height: 67.3143,
    rx: 5.31429,
    fill: "#ECECEC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35.1143,
    y: 21.8286,
    width: 44.2857,
    height: 8.85714,
    rx: 4.42857,
    fill: "#DEE3E5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 92.6855,
    y: 21.8286,
    width: 44.2857,
    height: 8.85714,
    rx: 4.42857,
    fill: "#DEE3E5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 249.457,
    y: 21.8286,
    width: 44.2857,
    height: 8.85714,
    rx: 4.42857,
    fill: "#DEE3E5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_679_28302)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 15.6285,
    width: 290.514,
    height: 113.371,
    rx: 7.08571,
    fill: "white"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 21.8286,
    y: 51.0571,
    width: 82.3714,
    height: 67.3143,
    rx: 5.31429,
    fill: "#ECECEC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 110.4,
    y: 51.0571,
    width: 81.4857,
    height: 67.3143,
    rx: 5.31429,
    fill: "#ECECEC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 198.086,
    y: 51.0571,
    width: 82.3714,
    height: 67.3143,
    rx: 5.31429,
    fill: "#ECECEC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 21.8286,
    y: 32.4572,
    width: 44.2857,
    height: 8.85714,
    rx: 4.42857,
    fill: "#DEE3E5"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 79.3999,
    y: 32.4572,
    width: 44.2857,
    height: 8.85714,
    rx: 4.42857,
    fill: "#DEE3E5"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 236.171,
    y: 32.4572,
    width: 44.2857,
    height: 8.85714,
    rx: 4.42857,
    fill: "#DEE3E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_679_28302",
    x: 13.8571,
    y: 0.571429,
    width: 299.371,
    height: 122.229,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.885714,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_679_28302"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.77143
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_679_28302"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_679_28302",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_679_28302",
    x: 0.571429,
    y: 11.2,
    width: 299.371,
    height: 122.229,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.885714,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_679_28302"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.77143
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_679_28302"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_679_28302",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifecycleBoard);
export default __webpack_public_path__ + "static/media/lifecycle-board.3b10abcbf07e749210fcde865050057f.svg";
export { ForwardRef as ReactComponent };